import { render, staticRenderFns } from "./Slogan.vue?vue&type=template&id=83aa3eca&scoped=true&"
import script from "./Slogan.vue?vue&type=script&lang=js&"
export * from "./Slogan.vue?vue&type=script&lang=js&"
import style0 from "./Slogan.vue?vue&type=style&index=0&id=83aa3eca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83aa3eca",
  null
  
)

export default component.exports